import React, { useState, useEffect } from 'react';
import { Badge, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { getUnreadAlertCount } from '@/pages/Pam/Security/Alerts/service';

const AlertBell: React.FC = () => {
  const [count, setCount] = useState(0);

  const fetchCount = async () => {
    try {
      const res = await getUnreadAlertCount();
      if (res?.success && res?.data) {
        setCount(res.data.total);
      }
    } catch {
      // 静默失败，不影响页面
    }
  };

  useEffect(() => {
    fetchCount();
    // 每 60 秒刷新一次
    const timer = setInterval(fetchCount, 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Tooltip title={count > 0 ? `${count} 条未处理告警` : '暂无告警'}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 26,
          cursor: 'pointer',
        }}
        onClick={() => history.push('/pam/security/alerts')}
      >
        <Badge count={count} size="small" offset={[2, -2]}>
          <BellOutlined style={{ fontSize: 16 }} />
        </Badge>
      </div>
    </Tooltip>
  );
};

export default AlertBell;
